import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import Image from "react-bootstrap/Image";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import EyeIcon from "../../assets/icons/Eye-15px-Gray-80.svg";
import EyeCrossedIcon from "../../assets/icons/Eye-Crossed-15px-Gray-80.svg";
import TickedCircleGreen from "../../assets/icons/Checkbox-Circular-Ticked-14px-Green-60.svg";
import TickedCircleGray from "../../assets/icons/Checkbox-Circular-Ticked-14px-Gray-30.svg";
import PropTypes from "prop-types";
import "./PasswordControl.scss";

const Requirement = ({ isValid, detail }) => {
  const img = isValid ? TickedCircleGreen : TickedCircleGray;
  const selected = isValid ? "selected" : "unselected";
  return (
    <div className="requirement">
      <Image src={img} />
      <p className={`requirement-info ${selected}`}>{detail}</p>
    </div>
  );
};

Requirement.propTypes = {
  isValid: PropTypes.bool.isRequired,
  detail: PropTypes.string.isRequired,
}

const PasswordControl = ({ onChange, value, isInvalid, errorMessage }) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  return (
    <OverlayTrigger
      show={isInvalid && !errorMessage}
      key="bottom"
      placement="bottom"
      overlay={
        <Popover className="popover-password popover">
          <Popover.Content className="popover-content">
            <div className="requirements-container">
              <div className="heading">Your password must have:</div>
              <Requirement isValid={value.length > 7} detail="8 or more characters" />
              <Requirement isValid={/([a-z])/.test(value) && /([A-Z])/.test(value)} detail="upper & lowercase letters" />
              <Requirement isValid={/([\d])/.test(value)} detail="at least one number" />
            </div>
          </Popover.Content>
        </Popover>
      }
    >
      <Form.Group className="form-group-container form-group-password-field" noValidate>
        <div className="icon-image-container">
          <Form.Control
            type={isPasswordVisible ? "text" : "password"}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            isInvalid={isInvalid}
            required
            autoComplete="off"
        />
          <Image data-mdb-ripple-color="light"
            onClick={() => setIsPasswordVisible(!isPasswordVisible)}
            className={`icon-image passwordVisibilityToggle`}
            src={isPasswordVisible ? EyeCrossedIcon : EyeIcon}
            alt="Show Password"
          />
        {errorMessage &&
          <Form.Control.Feedback type="invalid">
            {errorMessage}
          </Form.Control.Feedback>
        }
        </div>
      </Form.Group>
    </OverlayTrigger>
  );
};

PasswordControl.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  isInvalid: PropTypes.bool.isRequired,
}

export default PasswordControl;